import styled from 'styled-components';

export const ContractsAndConstructionsHomeHeader = styled.header`
  display: flex;
  flex-direction: column;

  width: 97%;
  margin: 1rem auto;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto;
    max-width: initial;
    padding: 0;
  }

  & > .title {
    font-size: 1.625rem;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  & > .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }

  & > .description-facelift {
    font-family: ${({ theme }) => theme.fonts.workSans};
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${({ theme }) => theme.colors.grayDark4};
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding-bottom: 1rem;

  & > div.content {
    display: flex;
    flex-direction: column;

    width: 97%;
    margin: 1rem auto 6rem auto;

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
      max-width: initial;
    }
  }
`;

export const CustomersTableContainer = styled.div`
  width: 100%;
  border-radius: 4px;
`;
